import {gql, useQuery} from "@apollo/client";
import type {GetRateAgreementById, GetRateAgreementByIdVariables} from "./schema/GetRateAgreementById";

export const getRateAgreementByIdQuery = gql`
    query GetRateAgreementById($id: ID!) {
        rates {
            rateAgreementById(rateAgreementId: $id) {
                id
                name
                description
                carrier
                serviceMethod
                status
                audit {
                    latestChange {
                        changedBy
                        changedAt
                    }
                }
                rateTables {
                    id
                    name
                    type
                    currency
                    description
                    validFrom
                    validTo
                    useMinimumProcedure
                    rateStructure {
                        pickupLocationFilters {
                            column
                            displayName
                            operator
                        }
                        deliveryLocationFilters {
                            column
                            displayName
                            operator
                        }
                        serviceOptionFilters {
                            column
                            displayName
                            operator
                        }
                        primaryQuantity {
                            column
                            unit
                            ranges {
                                upperBound
                                costType
                                unitQuantity
                            }
                        }
                        additionalQuantities {
                            column
                            unit
                            ranges {
                                upperBound
                            }
                        }
                    }
                }
            }
        }
    }
`;

export function useRateAgreementById(id: string) {
    const {data, loading, error} = useQuery<
        GetRateAgreementById,
        GetRateAgreementByIdVariables
    >(getRateAgreementByIdQuery, {
        variables: {id},
        skip: !id
    });
    const rateAgreement = data?.rates?.rateAgreementById ?? null;
    return {
        rateAgreement,
        // Treat as loaded as soon as we have data — avoids re-showing skeletons
        // when navigating between rate tables of the same already-cached agreement.
        loading: loading && rateAgreement == null,
        error
    };
}
